/*
 * @Description:
 * @Autor: Zhongyu
 * @Date: 2021-04-27 16:21:24
 * @LastEditors: Zhongyu
 * @LastEditTime: 2021-05-28 18:03:13
 */

/**
 * 深拷贝，支持常见类型
 */
export default function deepClone(values) {
  let copy;

  // Handle the 3 simple types, and null or undefined
  if (null === values || "object" !== typeof values) {
    return values;
  }

  // Handle Date
  if (values instanceof Date) {
    copy = new Date();
    copy.setTime(values.getTime());
    return copy;
  }

  // Handle Array
  if (values instanceof Array) {
    copy = [];
    for (let i = 0, len = values.length; i < len; i++) {
      copy[i] = deepClone(values[i]);
    }
    return copy;
  }

  // Handle Object
  if (values instanceof Object) {
    copy = {};
    for (const attr in values) {
      if (values.hasOwnProperty(attr)) {
        copy[attr] = deepClone(values[attr]);
      }
    }
    return copy;
  }

  throw new Error("Unable to copy values! Its type isn't supported.");
}
